<!--
  ModalSettingArguments.vue
  ロボ引用設定モーダル
  ロボに引用を設定する

  coller
    ScenarioList.vue
-->
<template>
  <section>
    <b-modal :active.sync="isCardModalActive">
        <div class="card" style="border-radius: 5px;">
          <header class="card-header">
            <p class="card-header-title">
              ロボ引用の設定
            </p>
          </header>
          <div class="card-body">
            <div>
              <span style="text-align: left;">
                <b-field>
                  <!-- ロボ引用設定 -->
                  <div>
                    <p style="text-align: left; width: 100%;">ロボ引用設定</p>
                    <p style="text-align: left; width: 100%;">※この設定は、メールテンプレートおよびSMSテンプレートでロボリンクを指定した場合にのみ有効です。</p>
                    <div class="argument-list disp-scroll" style="padding: 16px;" v-if="applicantColumns().length > 0">
                      <fieldset :disabled="isDisabled() === true">
                        <div v-for="(argument, argIndex) in inputArguments" :key="argIndex">
                          <b-field>
                            <!-- カスタムカラム選択 -->
                            <p class="column-title">第{{argIndex + 1}}ロボ引用：</p>
                            <select class="column-select select" v-model="inputArguments[argIndex]">
                              <option v-for="(column, colIndex) in applicantColumns()" :key="colIndex" :value="column">
                                {{column.name}}
                              </option>
                            </select>
                            <!-- ロボ引用追加ボタン -->
                            <button
                              class="button is-small"
                              style="background: #f8f8f8;"
                              @click="addItem(argIndex)"
                              :disabled="isDisabledAdd()">
                              <span class="mdi mdi-plus-box"></span>
                            </button>
                            <!-- ロボ引用削除ボタン -->
                            <button
                              class="button is-small"
                              style="background: #f8f8f8;"
                              @click="delItem(argIndex)"
                              :disabled="isDisabledDel()">
                              <span class="mdi mdi-minus-box"></span>
                            </button>
                          </b-field>
                        </div>
                      </fieldset>
                    </div>
                    <!-- 応募者情報項目が存在しない場合 -->
                    <div style="padding: 16px;" v-else>
                      <p style="text-align: left; width: 100%;">応募者情報項目が存在しません。</p>
                    </div>
                  </div>
                </b-field>
              </span>
            </div>
          </div>
          <!-- フッター -->
          <footer class="card-footer">
            <!-- キャンセルボタン -->
            <a class="card-footer-item" @click="cancel()">
              キャンセル
            </a>
            <!-- 保存ボタン -->
            <a class="card-footer-item" @click="saveArguments()" v-if="isDisabled() === false">
              保存
            </a>
            <!-- ロボロック時保存ボタン -->
            <a class="card-footer-item" v-else>
              保存
            </a>
          </footer>
        </div>
    </b-modal>
  </section>
</template>

<script>
import { mapState } from 'vuex'
// 操作履歴Mixin
import controlLogMixin from '@/mixins/controlLogMixin'

export default {
  name: 'ModalSettingArguments',
  componentName: 'ModalSettingArguments',
  props: {
    /**
     * 編集中ロボ
     * @type {Object}
     */
    robo: {
      type: Object,
      required: true,
    },
    /**
     * 応募者管理画面のテーブル設定
     * @type {Array}
     */
    companyColumnSetting: {
      type: Array,
      required: true,
    },
  },
  data () {
    return {
      /**
       * 開閉フラグ
       * @type {Boolean}
       */
      isCardModalActive: false,
      /**
       * 設定済みロボ引用
       * @type {Array}
       */
      inputArguments: [],
    }
  },
  mixins: [
    // 操作履歴Mixin
    controlLogMixin
  ],
  computed: {
    // ロボ関連ストア
    ...mapState('chatbot', ['isModalSettingArguments']),
  },
  watch: {
    // ダイアログ開閉フラグ監視
    isModalSettingArguments () {
      this.isCardModalActive = this.isModalSettingArguments
    },
    // ダイアログ開閉時処理
    isCardModalActive () {
      if (!this.isCardModalActive) {
        // 後始末
        this.inputArguments = [{'pk': 'dummy'}]
        this.$store.dispatch('chatbot/closeModalScenario')
      } else {
        // 初期設定
        if (this.robo.robo_arguments && this.robo.robo_arguments.length > 0) {
          // 設定済みのロボ引用を取得する
          this.inputArguments = this.robo.robo_arguments
        } else {
          // 未設定の場合はダミーを入れる
          this.inputArguments = [{'pk': 'dummy'}]
        }
      }
    }
  },
  methods: {
    /**
     * 応募者情報項目取得
     */
    applicantColumns () {
      // ロボ引用対象外応募者情報カラム
      const roboArgumentsExcludeColumns = [
          // ファイル
          8,
          // 外部連携
          18,
          // ステージ
          19,
          // ステータス
          20,
          // アクション
          21,
          // 録画面接
          23,
          // フラグ
          24,
          // ロボ会話履歴
          25
      ]
      // 対象外カラムを除外する
      let filteredColumns = []
      for (const column of this.companyColumnSetting) {
        if (roboArgumentsExcludeColumns.includes(column.template_type) === false) {
          filteredColumns.push(column)
        }
      }
      return filteredColumns
    },
    /**
     * ロボロック判定
     */
    isDisabled () {
      if (this.robo.is_confirm) {
        // ロボロック中
        return true
      } else {
        // ロボ未ロック
        return false
      }
    },
    /**
     * ロボ引用追加判定
     */
    isDisabledAdd () {
      // ロボ引用は10個まで
      return this.isDisabled() || this.inputArguments.length >= 10
    },
    /**
     * ロボ引用削除判定
     */
    isDisabledDel () {
      // 最後の1つは削除させない
      return this.isDisabled() || (this.inputArguments.length <= 1 && this.inputArguments[0].pk === 'dummy')
    },
    /**
     * ロボ引用追加
     * @param {Number} idx 追加インデックス
     */
    addItem (idx) {
      // 指定した位置の次に新しいロボ引用を追加する
      this.inputArguments.splice(idx + 1, 0, {'pk': 'dummy'})
      this.sendControlLogRelatedChatBot('ロボ引用追加', 'ロボ引用設定画面にて、「引用追加」を実行。', this.robo)
    },
    /**
     * ロボ引用削除
     * @param {Number} idx 削除インデックス
     */
    delItem (idx) {
      // 指定した位置のロボ引用を削除する
      this.inputArguments.splice(idx, 1)
      if (this.inputArguments.length < 1) {
        this.inputArguments.push({'pk': 'dummy'})
      }
      this.sendControlLogRelatedChatBot('ロボ引用削除', 'ロボ引用設定画面にて、「引用削除」を実行。', this.robo)
    },
    /**
     * ロボ引用設定保存
     */
    saveArguments () {
      // 空のロボ引用を削除する
      const saveData = this.inputArguments.filter(arg => {return arg.pk !== 'dummy'})
      let saveColPk = []
      for (const col of saveData) {
        saveColPk.push(col.pk)
      }

      // 重複する設定を除外する
      saveColPk = [...new Set(saveColPk)]

      // 保存するときはargumentsにPKだけのリストを渡す
      let saveRobo = JSON.parse(JSON.stringify(this.robo))
      saveRobo.arguments = saveColPk
      this.isCardModalActive = false
      this.$store.dispatch('chatbot/setChatBot', saveRobo)
      this.sendControlLogRelatedChatBot('ロボ引用保存', 'ロボ引用設定画面にて、「引用保存」を実行。', this.robo)
    },
    /**
     * ダイアログを閉じる
     */
    cancel () {
      this.isCardModalActive = false
    }
  }
}
</script>

<style lang="scss" scoped>
.card-body {
  overflow-y: scroll;
  overflow-x: hidden;
  height: calc(100vh - 470px);
  padding: 16px;
}
.card-body::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}
.dot-line {
  height: 10px;
  width: 100%;
  background-image: url('../../../../assets/lp/dot.png');
  background-repeat: repeat-x;
  background-size: 10px;
  margin-top: 8px;
  margin-bottom: 8px;
}
.argument-list {
  height: calc(100vh - 550px);
  .column-title {
  width:120px;
  }
  .column-select {
    width:200px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/organisms/chatbot/modals/ModalSettingArguments.vue